import { createFileRoute } from "@tanstack/react-router";

import { AdminTabsLayout } from "src/components/AdminTabsLayout";

export const Route = createFileRoute("/_auth/_admin/admin/metrics")({
  component: RouteComponent,
  ssr: true,
  staticData: {
    getBreadcrumb({ i18n }) {
      return {
        label: i18n.t("sidebar.metrics"),
        href: "/admin/metrics",
      };
    },
  },
});

function RouteComponent() {
  return (
    <AdminTabsLayout
      label="Metrics sections"
      tabs={[
        { to: "/admin/metrics", label: "Metrics", exact: true },
        {
          to: "/admin/metrics/integration-configs",
          label: "Integration Configs",
        },
      ]}
    />
  );
}
